import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../styles/InputStyles";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import InputWrapper from "../../../input/wrapper/InputWrapper";
import Select from "../../../select/main/Select";
import FlowPlayerControls from "../../controls/FlowPlayerControls";

function ParkingLocationStepView({
  controller,
  onParkingLocationChange,
  onLicensePlateChange,
}) {
  const { translate } = useLanguageContext();

  return (
    <FlowPlayerControls controller={controller}>
      <StyledFlexColumn>
        <InputWrapper
          label={translate(
            "eva.frontoffice.pages.visitor_type.steps.parking_location.fields.parking_location_id",
          )}
          error={EVAApiHelper.getResponseError(
            "parking_location_id",
            controller.errors,
          )}
        >
          <Select
            nullable={true}
            placeholder={translate(
              "eva.frontoffice.pages.visitor_type.steps.parking_location.no_parking_needed",
            )}
            options={controller.step?.parking_locations?.map((pl) => ({
              value: pl.id,
              label: pl.name,
            }))}
            value={controller.visitorData.parking_location_id}
            onChange={onParkingLocationChange}
          />
        </InputWrapper>

        {controller.visitorData.parking_location_id && (
          <InputWrapper
            label={translate(
              "eva.frontoffice.pages.visitor_type.steps.parking_location.fields.license_plate",
            )}
            required={true}
            error={EVAApiHelper.getResponseError(
              "license_plate",
              controller.errors,
            )}
          >
            <StyledInput
              type="text"
              value={controller.visitorData.license_plate || ""}
              onChange={onLicensePlateChange}
            />
          </InputWrapper>
        )}
      </StyledFlexColumn>
    </FlowPlayerControls>
  );
}

export default ParkingLocationStepView;
